import { useCallback } from 'react';
import { useOrgConfigStateValue } from './business/useOrgConfig';
import { getImageThumb, getTiktokProxyImageSrc } from 'lib/utils/platformImage';

export const usePlatformResourceURL = () => {
  const { tiktokImageProxyOriginList } = useOrgConfigStateValue();

  const getImageResource = useCallback(
    (source: string, platform: General.PlatformUpperCaseTunnel) => {
      const needProxy = tiktokImageProxyOriginList?.some((origin) => source.includes(origin));
      const thumb = getImageThumb(source, platform);

      if (needProxy) {
        return {
          src: getTiktokProxyImageSrc(source),
          thumb: getTiktokProxyImageSrc(thumb),
        };
      }
      return {
        src: source,
        thumb: thumb,
      };
    },
    [tiktokImageProxyOriginList],
  );

  const getVideoResource = useCallback(
    (source: string, platform: General.PlatformUpperCaseTunnel, thumb?: string) => {
      const needProxy = tiktokImageProxyOriginList?.some((origin) => source.includes(origin));
      const finalThumb = thumb ? getImageThumb(thumb, platform) : thumb;
      if (needProxy) {
        return {
          src: getTiktokProxyImageSrc(source),
          thumb: finalThumb ? getTiktokProxyImageSrc(finalThumb) : finalThumb,
        };
      }
      return {
        src: source,
        thumb: finalThumb,
      };
    },
    [tiktokImageProxyOriginList],
  );

  return {
    getImageResource,
    getVideoResource,
  };
};
